
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","width":"18","height":"18","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 8.182A3.816 3.816 0 008.182 12 3.816 3.816 0 0012 15.818 3.816 3.816 0 0015.818 12 3.816 3.816 0 0012 8.182zm8.534 2.863a8.587 8.587 0 00-7.58-7.579V1.5h-1.909v1.966a8.587 8.587 0 00-7.579 7.58H1.5v1.909h1.966a8.587 8.587 0 007.58 7.579V22.5h1.909v-1.966a8.587 8.587 0 007.579-7.58H22.5v-1.909h-1.966zM12 18.682A6.677 6.677 0 015.318 12 6.677 6.677 0 0112 5.318 6.677 6.677 0 0118.682 12 6.677 6.677 0 0112 18.682z"}})])
          )
        }
      }
    